module.exports = __webpack_public_path__ + "img/greninja-min.ef8f9364.png";